import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MediaControlCard from './MediaControlCard';
import ClientProvider from './client';
export default createDemo(import.meta.url, MediaControlCard, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/cards/demos/media-control/MediaControlCard.tsx",
    "fileName": "MediaControlCard.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { useTheme } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport IconButton from '@mui/material/IconButton';\nimport Typography from '@mui/material/Typography';\nimport SkipPreviousIcon from '@mui/icons-material/SkipPrevious';\nimport PlayArrowIcon from '@mui/icons-material/PlayArrow';\nimport SkipNextIcon from '@mui/icons-material/SkipNext';\n\nexport default function MediaControlCard() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const theme = useTheme();\n\n  return (\n    <Card sx={{ display: 'flex' }}>\n      <Box sx={{ display: 'flex', flexDirection: 'column' }}>\n        <CardContent sx={{ flex: '1 0 auto' }}>\n          <Typography component=\"div\" variant=\"h5\">\n            Live From Space\n          </Typography>\n          <Typography\n            variant=\"subtitle1\"\n            component=\"div\"\n            sx={{ color: 'text.secondary' }}\n          >\n            Mac Miller\n          </Typography>\n        </CardContent>\n        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>\n          <IconButton aria-label=\"previous\">\n            {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}\n          </IconButton>\n          <IconButton aria-label=\"play/pause\">\n            <PlayArrowIcon sx={{ height: 38, width: 38 }} />\n          </IconButton>\n          <IconButton aria-label=\"next\">\n            {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}\n          </IconButton>\n        </Box>\n      </Box>\n      <CardMedia\n        component=\"img\"\n        sx={{ width: 151 }}\n        image=\"/static/images/cards/live-from-space.jpg\"\n        alt=\"Live from space album cover\"\n      />\n    </Card>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 50,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { useTheme } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport IconButton from '@mui/material/IconButton';\nimport Typography from '@mui/material/Typography';\nimport SkipPreviousIcon from '@mui/icons-material/SkipPrevious';\nimport PlayArrowIcon from '@mui/icons-material/PlayArrow';\nimport SkipNextIcon from '@mui/icons-material/SkipNext';\n\nexport default function MediaControlCard() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const theme = useTheme();\n\n  return (\n    <Card sx={{ display: 'flex' }}>\n      <Box sx={{ display: 'flex', flexDirection: 'column' }}>\n        <CardContent sx={{ flex: '1 0 auto' }}>\n          <Typography component=\"div\" variant=\"h5\">\n            Live From Space\n          </Typography>\n          <Typography\n            variant=\"subtitle1\"\n            component=\"div\"\n            sx={{ color: 'text.secondary' }}\n          >\n            Mac Miller\n          </Typography>\n        </CardContent>\n        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>\n          <IconButton aria-label=\"previous\">\n            {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}\n          </IconButton>\n          <IconButton aria-label=\"play/pause\">\n            <PlayArrowIcon sx={{ height: 38, width: 38 }} />\n          </IconButton>\n          <IconButton aria-label=\"next\">\n            {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}\n          </IconButton>\n        </Box>\n      </Box>\n      <CardMedia\n        component=\"img\"\n        sx={{ width: 151 }}\n        image=\"/static/images/cards/live-from-space.jpg\"\n        alt=\"Live from space album cover\"\n      />\n    </Card>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 50,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Card",
      "@mui/material/CardContent",
      "@mui/material/CardMedia",
      "@mui/material/IconButton",
      "@mui/material/Typography",
      "@mui/icons-material/SkipPrevious",
      "@mui/icons-material/PlayArrow",
      "@mui/icons-material/SkipNext"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
